import React from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import Icon from "@/components/Icon";

export default function ImpersonationBanner() {
  const { user, checkAuth } = useAuth();
  if (!user || !user._impersonated_by) return null;
  const stop = async () => {
    try { await api.post("/admin/impersonate/stop"); } catch {}
    await checkAuth();
    window.location.href = "/admin";
  };
  return (
    <div data-testid="impersonation-banner" className="fixed top-0 inset-x-0 z-[100] bg-amber-500 text-black text-sm font-semibold px-4 py-2 flex items-center justify-center gap-3 shadow">
      <Icon name="Eye" className="h-4 w-4" />
      Read-only support session — viewing as <span className="font-bold">{user.email}</span>
      <button data-testid="exit-impersonation" onClick={stop} className="ml-2 rounded-lg bg-black/85 text-white px-3 py-1 text-xs font-bold hover:bg-black">Exit support session</button>
    </div>
  );
}
